import * as React from 'react';
import { UIHeading2, useDeviceType, Body1 } from '@cian/ui-kit';
import cn from 'clsx';

import styles from './styles.css';

interface IFormProps extends React.PropsWithChildren {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}

export const FormWrapper: React.FC<IFormProps> = ({ title, children, subtitle }) => {
  const deviceType = useDeviceType();

  return (
    <form className={cn(styles['form'], styles[deviceType])} data-testid="leave-contacts-modal-form">
      <div className={styles['form-title']}>
        <UIHeading2 whiteSpace="pre-line">{title}</UIHeading2>
        {subtitle && (
          <Body1 color="text-secondary-default" whiteSpace="pre-line">
            {subtitle}
          </Body1>
        )}
      </div>
      {children}
    </form>
  );
};
